exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.profile {\n  margin-left: 10px;\n  margin-right: 10px;\n}\n.header li {\n  cursor: pointer;\n}\n", "", {"version":3,"sources":["D:/a/1/RTPS-CopayePA-Portal/src/components/profile.vue"],"names":[],"mappings":";AACA;EACE,kBAAkB;EAClB,mBAAmB;CACpB;AACD;EACE,gBAAgB;CACjB","file":"profile.vue","sourcesContent":["\n.profile {\n  margin-left: 10px;\n  margin-right: 10px;\n}\n.header li {\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f318cfe0","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/profile.vue
// module id = zups
// module chunks = 1